module.exports = __webpack_public_path__ + "static/media/loader.ac22bbc0.svg";